module.exports = __webpack_public_path__ + "banquet/components/Banquet/images/apple-touch-icon-76.42069d691fe5d0be7ec38e9d4c63ee35.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Banquet/images/apple-touch-icon-76.png
// module id = 1659
// module chunks = 1